module.exports = __webpack_public_path__ + "img/woman-avatar.f5216a14.svg";